import TextArea, { TextAreaProps } from "antd/lib/input/TextArea";
import "./styles.scss";
import React from "react";

const TierTextArea: React.FC<TextAreaProps> = ({ className, ...props }) => {
  return <TextArea className={`tier-textarea ${className || className}`} {...props}></TextArea>;
};

export default TierTextArea;
